import { inject, Injectable } from '@angular/core';
import { Router, type CanActivate, type GuardResult } from '@angular/router';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { UserRepository } from '../state/user.repository';

@Injectable({ providedIn: 'any' })
export class UserAnonymousGuard implements CanActivate {
    private readonly userRepository = inject(UserRepository);
    private readonly router = inject(Router);
    private readonly environmentService = inject(EnvironmentService);

    // eslint-disable-next-line sonarjs/function-return-type
    public canActivate(): GuardResult {
        if (this.userRepository.getToken() === undefined) {
            return true;
        }

        return this.router.parseUrl(this.environmentService.privatePath);
    }
}
